module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.emptyFlag) ? _c('div', {
    staticClass: "tab_Topic"
  }, [_c('ul', {
    staticClass: "clearfix tabBt_e",
    class: {
      tabBt: false
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoAnswer),
      expression: "infoAnswer"
    }],
    class: {
      topic_Active: _vm.topicActive == 1
    },
    on: {
      "click": function($event) {
        _vm.topicAct(1)
      }
    }
  }, [_vm._v("参考答案")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.explains[0]),
      expression: "explains[0]"
    }],
    class: {
      topic_Active: _vm.topicActive == 3
    },
    on: {
      "click": function($event) {
        _vm.topicAct(3)
      }
    }
  }, [_vm._v("试题解析")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.knowledgePoints.length > 0),
      expression: "knowledgePoints.length>0"
    }],
    class: {
      topic_Active: _vm.topicActive == 2
    },
    on: {
      "click": function($event) {
        _vm.topicAct(2)
      }
    }
  }, [_vm._v("考点")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.skillPoints.length > 0),
      expression: "skillPoints.length>0"
    }],
    class: {
      topic_Active: _vm.topicActive == 5
    },
    on: {
      "click": function($event) {
        _vm.topicAct(5)
      }
    }
  }, [_vm._v("能力点")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tags),
      expression: "tags"
    }],
    class: {
      topic_Active: _vm.topicActive == 4
    },
    on: {
      "click": function($event) {
        _vm.topicAct(4)
      }
    }
  }, [_vm._v("试题标签")])]), _vm._v(" "), (_vm.topicActive == 1 && _vm.infoAnswer) ? _c('div', {
    staticClass: "Topic_bg"
  }, [_vm._l((_vm.infoAnswer), function(val, answerindex) {
    return (_vm.qtype == 1) ? _c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(val.index)))]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 2) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setRefAnswer(_vm.infoAnswer.options, _vm.infoAnswer.ref_info))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.infoAnswer), function(val, stemIndex) {
    return (_vm.qtype == 3) ? _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(val.stem)
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 8) ? _c('p', [_vm._v(_vm._s(_vm.setAnswers(_vm.infoAnswer)))]) : _vm._e(), _vm._v(" "), (_vm.qtype == 6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.setShortAnswer(_vm.infoAnswer))
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 2) ? _c('div', {
    staticClass: "Topic_bg"
  }, _vm._l((_vm.knowledgePoints), function(item, index) {
    return _c('span', {
      staticClass: "topc_knowledgeP"
    }, [_vm._v(_vm._s(item.point_displayname))])
  })) : _vm._e(), _vm._v(" "), (_vm.topicActive == 3 && _vm.explains) ? _c('div', {
    staticClass: "Topic_bg"
  }, [_c('div', {
    staticClass: "clearfix m-b20",
    domProps: {
      "innerHTML": _vm._s(_vm.explains[0].context)
    }
  }), _vm._v(" "), _vm._l((_vm.explains[0].attachments), function(item, index) {
    return (_vm.explains[0].attachments.length > 0) ? _c('div', {
      staticClass: "m-b20"
    }, [(item.file_type == 2) ? _c('div', {
      staticClass: "button",
      class: _vm.myIsPlay ? 'play' : 'pause',
      on: {
        "click": _vm.player
      }
    }, [_c('audio', {
      attrs: {
        "src": item.file_url,
        "preload": "auto"
      }
    })]) : _vm._e(), _vm._v(" "), (item.file_type == 3 && _vm.videoP) ? _c('div', {
      staticClass: "coverUrl",
      on: {
        "click": _vm.videoPlayer
      }
    }, [_c('img', {
      staticClass: "coverVodio",
      attrs: {
        "src": item.cover_Url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "coverUrlPlay",
      attrs: {
        "src": require("./../../assets/img/player.png")
      }
    })]) : _vm._e(), _vm._v(" "), _c('embed', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.file_type == 3 && !_vm.videoP),
        expression: "item.file_type==3 && !videoP"
      }],
      attrs: {
        "src": "http://yuntv.letv.com/bcloud.swf",
        "pic": "item.cover_Url",
        "allowFullScreen": "true",
        "quality": "high",
        "width": "300",
        "height": "150",
        "align": "middle",
        "allowScriptAccess": "always",
        "flashvars": _vm.videoSrc(item.file_url),
        "type": "application/x-shockwave-flash"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.explains[0].lecturer) ? _c('div', [_c('b', [_vm._v("主讲教师:  ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.explains[0].lecturer))]), _vm._v(" "), (_vm.explains[0].tags) ? _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, _vm._l((_vm.explains[0].tags.split(',')), function(tag, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(tag))])
  })) : _vm._e()]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 4) ? _c('div', {
    staticClass: "Topic_bg"
  }, _vm._l((_vm.tags), function(item, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e(), _vm._v(" "), (_vm.topicActive == 5) ? _c('div', _vm._l((_vm.skillPoints), function(item, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30cf4950","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/tabTopic.vue
// module id = 1177
// module chunks = 1